
<script>
export default {
  name: 'user-menu',
  computed: {
    isUserLoggedIn() {
      return this.$store.getters['account/getAccess']
    },
    userProfile() {
      return this.$store.getters['profile/getUserProfile']
    },
  },
  methods: {
    logout() {
      this.$store.commit('account/logout')
    }
  }
}
</script>

<template>
  <b-dropdown
    v-if="isUserLoggedIn"
    :hoverable="true"
    aria-role="list"
    class="app-header__dropdown app-header__user-info"
    position="is-bottom-left"
  >
    <button
      slot="trigger"
      class="app-header__dropdown-button button"
      :title="userProfile.fullname"
    >
      <span
        class="app-header__user-name"
      >
        {{ userProfile.fullname }}
      </span>
      <b-icon icon="menu-down" />
    </button>
    <b-dropdown-item
      :has-link="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :to="{
          name: 'Lk'
        }"
      >
        Личный кабинет
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      :has-link="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :to="{
          name: 'MyAgency'
        }"
      >
        Профиль и статистика
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      :has-link="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :to="{
          name: 'ListOrders'
        }"
      >
        Список заказов
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      :has-link="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :to="{
          name: 'Favorites'
        }"
      >
        Избранное
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      :disabled="true"
      :has-link="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :event="''"
        :to="{
          name: 'Main'
        }"
      >
        Бонусы и статистика
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      :disabled="true"
      :has-link="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :event="''"
        :to="{
          name: 'Main'
        }"
      >
        Договоры и отчеты
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      :disabled="true"
      :has-link="true"
      aria-role="listitem"
      class="app-header__dropdown-item"
    >
      <router-link
        :event="''"
        :to="{
          name: 'Main'
        }"
      >
        Отчет агента
      </router-link>
    </b-dropdown-item>
    <b-dropdown-item
      aria-role="listitem"
      class="app-header__dropdown-item"
      @click="logout"
    >
      Выйти
    </b-dropdown-item>
  </b-dropdown>
</template>
